import bridge from '@vkontakte/vk-bridge'
import axios from '@/marketplace'
import { assignColorsToCssVariables } from '@/helpers/colors'

export default class VkMiniApp {
  constructor(odrEnabled, groupId) {
    this.odrEnabled = odrEnabled
    this.groupId = groupId
  }

  execute() {
    return new Promise(resolve => {
      if (!this.odrEnabled || !this.groupId) {
        return resolve()
      }

      this.loadState()
        .then(() => resolve())
        .catch(() => resolve())
    })
  }

  init() {
    console.log('[VkMiniApp] Sending VKWebAppInit event.')

    bridge.send('VKWebAppInit')
      .then(result => console.log('[VkMiniApp] App initialized.', result))
      .catch(err => console.error('[VkMiniApp] Unable to initialize app.', err))
  }

  loadState() {
    return new Promise(resolve => {
      axios.get(`websites/vk/${this.groupId}/state`)
        .then(({ data }) => {
          console.log('[VKMiniApp] State has been loaded.', { state: data.data })
          window.__appState = data.data.app_state
          window.__appState.custom_context = window.__appState.custom_context || {}
          window.__appState.custom_context.vk_mini_app = true
          assignColorsToCssVariables(data.data.app_state.style.colors)

          return resolve()
        })
        .catch(err => {
          console.error('[VkMiniApp] Unable to load state', { err })

          return resolve()
        })
    })
  }
}
